export const MOON = [
  {
    Lv: '1',
    HP: '32',
    MP: '28',
    POW: '2',
    SPD: '22',
    DEF: '11',
    EX: '0',
    NEXT: '100'
  },
  {
    Lv: '2',
    HP: '32',
    MP: '28',
    POW: '2',
    SPD: '26',
    DEF: '13',
    EX: '100',
    NEXT: '200'
  },
  {
    Lv: '3',
    HP: '37',
    MP: '35',
    POW: '2',
    SPD: '26',
    DEF: '13',
    EX: '300',
    NEXT: '300'
  },
  {
    Lv: '4',
    HP: '37',
    MP: '44',
    POW: '3',
    SPD: '28',
    DEF: '14',
    EX: '600',
    NEXT: '600'
  },
  {
    Lv: '5',
    HP: '38',
    MP: '48',
    POW: '3',
    SPD: '33',
    DEF: '16',
    EX: '1200',
    NEXT: '1200'
  },
  {
    Lv: '6',
    HP: '39',
    MP: '48',
    POW: '4',
    SPD: '40',
    DEF: '19',
    EX: '2400',
    NEXT: '1800'
  },
  {
    Lv: '7',
    HP: '40',
    MP: '50',
    POW: '5',
    SPD: '42',
    DEF: '20',
    EX: '4200',
    NEXT: '2200'
  },
  {
    Lv: '8',
    HP: '45',
    MP: '52',
    POW: '6',
    SPD: '47',
    DEF: '22',
    EX: '6400',
    NEXT: '2600'
  },
  {
    Lv: '9',
    HP: '50',
    MP: '58',
    POW: '7',
    SPD: '50',
    DEF: '23',
    EX: '9000',
    NEXT: '3000'
  },
  {
    Lv: '10',
    HP: '56',
    MP: '63',
    POW: '8',
    SPD: '55',
    DEF: '25',
    EX: '12000',
    NEXT: '4000'
  },
  {
    Lv: '11',
    HP: '58',
    MP: '69',
    POW: '8',
    SPD: '56',
    DEF: '25',
    EX: '16000',
    NEXT: '4000'
  },
  {
    Lv: '12',
    HP: '59',
    MP: '71',
    POW: '9',
    SPD: '58',
    DEF: '26',
    EX: '20000',
    NEXT: '5000'
  },
  {
    Lv: '13',
    HP: '62',
    MP: '75',
    POW: '10',
    SPD: '63',
    DEF: '28',
    EX: '25000',
    NEXT: '6000'
  },
  {
    Lv: '14',
    HP: '68',
    MP: '80',
    POW: '11',
    SPD: '69',
    DEF: '31',
    EX: '31000',
    NEXT: '8000'
  },
  {
    Lv: '15',
    HP: '75',
    MP: '86',
    POW: '12',
    SPD: '72',
    DEF: '32',
    EX: '39000',
    NEXT: '11000'
  },
  {
    Lv: '16',
    HP: '80',
    MP: '94',
    POW: '15',
    SPD: '78',
    DEF: '35',
    EX: '50000',
    NEXT: '15000'
  },
  {
    Lv: '17',
    HP: '89',
    MP: '96',
    POW: '17',
    SPD: '81',
    DEF: '36',
    EX: '65000',
    NEXT: '18000'
  },
  {
    Lv: '18',
    HP: '97',
    MP: '105',
    POW: '18',
    SPD: '85',
    DEF: '38',
    EX: '83000',
    NEXT: '20000'
  },
  {
    Lv: '19',
    HP: '105',
    MP: '114',
    POW: '20',
    SPD: '87',
    DEF: '39',
    EX: '103000',
    NEXT: '22000'
  },
  {
    Lv: '20',
    HP: '112',
    MP: '121',
    POW: '20',
    SPD: '96',
    DEF: '43',
    EX: '125000',
    NEXT: '25000'
  },
  {
    Lv: '21',
    HP: '124',
    MP: '124',
    POW: '23',
    SPD: '100',
    DEF: '45',
    EX: '150000',
    NEXT: '30000'
  },
  {
    Lv: '22',
    HP: '133',
    MP: '126',
    POW: '25',
    SPD: '110',
    DEF: '50',
    EX: '180000',
    NEXT: '40000'
  },
  {
    Lv: '23',
    HP: '138',
    MP: '137',
    POW: '29',
    SPD: '117',
    DEF: '53',
    EX: '220000',
    NEXT: '50000'
  },
  {
    Lv: '24',
    HP: '139',
    MP: '144',
    POW: '33',
    SPD: '117',
    DEF: '53',
    EX: '270000',
    NEXT: '30000'
  },
  {
    Lv: '25',
    HP: '142',
    MP: '149',
    POW: '35',
    SPD: '120',
    DEF: '54',
    EX: '300000',
    NEXT: '30000'
  },
  {
    Lv: '26',
    HP: '146',
    MP: '158',
    POW: '36',
    SPD: '123',
    DEF: '55',
    EX: '330000',
    NEXT: '30000'
  },
  {
    Lv: '27',
    HP: '147',
    MP: '165',
    POW: '36',
    SPD: '128',
    DEF: '57',
    EX: '360000',
    NEXT: '40000'
  },
  {
    Lv: '28',
    HP: '148',
    MP: '170',
    POW: '37',
    SPD: '132',
    DEF: '59',
    EX: '400000',
    NEXT: '50000'
  },
  {
    Lv: '29',
    HP: '155',
    MP: '171',
    POW: '40',
    SPD: '135',
    DEF: '60',
    EX: '450000',
    NEXT: '90000'
  }
]
